import React from "react";

export const PictureIcon: React.FC<{ className?: string }> = ({
    className
}) => (
    <svg
        className={className}
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path d="M6 28H4V6H6V28Z" fill="currentColor" />
        <path d="M28 26H26V4H28V26Z" fill="currentColor" />
        <path d="M26 26V28H6V26H26Z" fill="currentColor" />
        <path d="M26 4V6H6V4H26Z" fill="currentColor" />
        <path
            d="M11.6569 13.5858L13.0711 15L6 22.071L4.58579 20.6568L11.6569 13.5858Z"
            fill="currentColor"
        />
        <path
            d="M17.3111 19.2426L15.8968 20.6569L10.24 15L11.6542 13.5858L17.3111 19.2426Z"
            fill="currentColor"
        />
        <path
            d="M27.6434 23.9051L26.2292 25.3193L17.3199 16.41L18.7342 14.9958L27.6434 23.9051Z"
            fill="currentColor"
        />
        <path
            d="M18.7285 15L20.1427 16.4142L15.9 20.6569L14.4858 19.2426L18.7285 15Z"
            fill="currentColor"
        />
        <path
            d="M22 11C22 12.1046 21.1046 13 20 13C18.8954 13 18 12.1046 18 11C18 9.89543 18.8954 9 20 9C21.1046 9 22 9.89543 22 11Z"
            fill="currentColor"
        />
    </svg>
);
